export default __webpack_public_path__ + "static/testimonial-250822e5fe670b75de4c33b15b4be75c.webp";